// app/javascript/projects.js

export function initProjects() {
  const form = document.getElementById("projectForm");
  if (!form) return;

  const offcanvasElement = document.getElementById("eistProjectFormModal");
  if (offcanvasElement) {
    offcanvasElement.addEventListener("show.bs.offcanvas", function (event) {
      const button = event.relatedTarget;
      if (!button) return;

      const action = button.getAttribute("data-action");

      if (action === "edit") {
        form.dataset.projectId = button.getAttribute("data-project-id");

        // ✅ Hydrate new fields
        document.getElementById("project_customer_name").value =
          button.getAttribute("data-project-customer-name") || "";
        document.getElementById("project_company_name").value =
          button.getAttribute("data-project-company-name") || "";
        document.getElementById("project_address").value =
          button.getAttribute("data-project-address") || "";
        document.getElementById("project_project_name").value =
          button.getAttribute("data-project-project-name") || "";

        document.getElementById("project_description").value =
          button.getAttribute("data-project-description") || "";
        document.getElementById("project_status").value =
          button.getAttribute("data-project-status") || "prematured";
        document.getElementById("project_start_date").value =
          button.getAttribute("data-project-start-date") || "";
        document.getElementById("project_end_date").value =
          button.getAttribute("data-project-end-date") || "";
        document.getElementById("project_date_received").value =
        button.getAttribute("data-project-date-received") || "";
            } else {
        form.dataset.projectId = "";
        form.reset();
      }
    });
  }

  const saveBtn = document.getElementById("saveProjectBtn");
  if (saveBtn) {
    saveBtn.onclick = function () {
      const projectId = form.dataset.projectId;
      const url = projectId ? `/projects/${projectId}` : "/projects";
      const method = projectId ? "PATCH" : "POST";

      const payload = {
        customer_name: document.getElementById("project_customer_name").value,
        company_name: document.getElementById("project_company_name").value,
        address: document.getElementById("project_address").value,
        project_name: document.getElementById("project_project_name").value,
        description: document.getElementById("project_description").value,
        status: document.getElementById("project_status").value,
        start_date: document.getElementById("project_start_date").value,
        end_date: document.getElementById("project_end_date").value,
        date_received: document.getElementById("project_date_received").value   // ✅ added
      };


      fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
        },
        body: JSON.stringify({ project: payload })
      })
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            window.location.reload();
          } else {
            if (data.errors && Array.isArray(data.errors)) {
              alert(data.errors.join(", "));
            } else {
              alert(data.error || "An error occurred during project mutations");
            }
          }
        })
        .catch(error => {
          console.error("Communication failure:", error);
          alert("Network error processing project entry");
        });
    };
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProjects);
} else {
  initProjects();
}
